import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Jan 14 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, KpiRecordConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var KpiLayer =
/*#__PURE__*/
function () {
  function KpiLayer() {
    _classCallCheck(this, KpiLayer);
  }

  _createClass(KpiLayer, [{
    key: "findDescriptions",

    /**
     * Retrieves set of available KPIs
     * @returns Promise with KpiDescription list
     */
    value: function findDescriptions() {
      return api(CONSTANTS.API.ENDPOINTS.KPI_DESCRIPTION).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data.result;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "findSets",

    /**
     * Fetches all KPI sets for provided KPI set.
     * @param setPeerType - Entity name [SessionInfo, Promotion]
     * @param setPeerId - id based on peerType [session.id, promotion.id]
     * @param setKey - defined key from KpiEngineSetKeyEnum
     * @returns Promise with KpiRecord[]
     */
    value: function findSets(setPeerType, setPeerId, setKey) {
      var _this = this;

      return api(CONSTANTS.API.ENDPOINTS.KPI_SETS(setPeerType, setPeerId, setKey)).get({
        responseType: 'json'
      }).then(function (response) {
        var records = [];
        (response.data.result || []).map(function (record) {
          records.push(_this.kpiRecordConverter.toObject(record, jsonConversions));
        });
        return records;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "findRecords",

    /**
     * Fetches all KPI records for provided KPI set.
     * @param specs - array of IKpiRecordSetSpec
     * @returns Promise with KpiRecord[]
     */
    value: function findRecords(specs) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.KPI_RECORDS).post({
        specs: specs
      }, {
        responseType: 'json'
      }).then(function (response) {
        var records = [];
        (response.data.result || []).map(function (record) {
          records.push(_this2.kpiRecordConverter.toObject(record, jsonConversions));
        });
        return records;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return KpiLayer;
}();

__decorate([Inject, __metadata("design:type", KpiRecordConverter)], KpiLayer.prototype, "kpiRecordConverter", void 0);